import clsx from 'clsx';
import styles from './line-select.module.css';
import { LineSelectProps } from './line-select.props';

export const LineSelect = <T extends number | string>({
	value,
	options,
	onChange,
	className,
	render: Option,
	...props
}: LineSelectProps<T>) => {
	return (
		<div className={clsx(styles.wrapper, className)} {...props}>
			{options.map((option) => {
				if (Option) {
					return (
						<Option
							option={option}
							isActive={option.value === value}
							onChange={() => onChange(option.value)}
							key={option.value}
						/>
					);
				}

				return (
					<div
						onClick={() => onChange(option.value)}
						className={clsx(styles.option, {
							[styles.active]: option.value === value,
						})}
						key={option.value}
					>
						<p className={styles.label}>{option.label}</p>
					</div>
				);
			})}
		</div>
	);
};
